import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ModalBody, ModalHeader, Button } from 'reactstrap'

import { Modal } from 'common-components/index'
import { setAppValue } from '../../../apps/actions'
import { getCurrentApp } from 'e-submission/apps/selectors'
import { Link } from 'react-router-dom'
import { insuredValidateField } from '../../AppForm/FormValidation/ekycValidation'
import _ from 'lodash'
import { getToggles } from 'quick-quote/feature-toggles'

function InsuredAndPayerDetailsConfirmation() {
  const dispatch = useDispatch()
  const [isSkipEkyc, setIsSkipEkyc] = useState(false)

  const app = useSelector((state) => getCurrentApp(state))
  const isDataConfirmed = _.get(app, `ekycInfo.isDataConfirmed`, false)
  const insured = app.insured
  const payer = app.payer

  const handleSetEkycDataConfirmed = () => {
    dispatch(setAppValue(`ekycInfo.isDataConfirmed`, true))
  }

  return (
    <Modal
      className={'insured-and-payer-details-confirmations-modal'}
      isOpen={
        !getToggles().ENABLE_EKYC_F2F_RECREATE_CASE &&
        !isDataConfirmed &&
        !insuredValidateField(payer).length &&
        !insuredValidateField(insured).length
      }
      size="md"
      modalClassName="default-bootstrap remote-selling-modal"
    >
      <ModalHeader className={'header-modal'}>กรุณายืนยันเพื่อเข้าสู่ขั้นตอนการยืนยันตัวตน</ModalHeader>
      <ModalBody>
        <div className={'normal-text detail-text'}>
          ท่านได้ตรวจสอบความถูกต้องของข้อมูลแล้วและต้องการไปยังหน้ายืนยันตัวตน ใช่หรือไม่?
        </div>
        <div className={'normal-text detail-text remark-text'}>
          หมายเหตุ: เมื่อคลิกยืนยันแล้วท่านจะไม่สามารถแก้ไขข้อมูลได้อีก
        </div>

        <div className={'normal-text'}>
          <Link to="insured">
            <Button className="back-button">ย้อนกลับ</Button>
          </Link>
          <Button color={'primary'} onClick={handleSetEkycDataConfirmed} className="primary">
            ยืนยัน
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default InsuredAndPayerDetailsConfirmation
